document.addEventListener('DOMContentLoaded', function() {
  // Only run on preorder products
  if (!document.body.classList.contains('template-product') && 
      !window.location.pathname.includes('preorder')) {
    return;
  }
  
  const productData = window.productData || {};
  const currentStockEl = document.getElementById('currentStock');
  const inventoryInfo = document.getElementById('inventoryInfo');
  
  if (!currentStockEl || !productData.variants || !inventoryInfo) {
    console.log('Inventory display: Not a preorder product or missing elements');
    return;
  }
  
  function getSelectedVariant() {
  const form = document.querySelector('.js-product-form');
  if (!form) return productData.variants[0];

  const variantIdInput = form.querySelector('[name="id"]');
  const selectedId = variantIdInput ? parseInt(variantIdInput.value) : null;

  return productData.variants.find(v => v.id === selectedId) || productData.variants[0];
}

    // Function to calculate current available stock
function calculateCurrentStock() {
  const variant = getSelectedVariant();
  if (!variant) return 0;

  return Number(variant.inventory_quantity) || 0;
}

  
  // Function to update inventory display
  function updateInventoryDisplay() {
  const variant = getSelectedVariant();
  if (!variant) return;

  const remaining = Number(variant.inventory_quantity) || 0;
  const total = productData.totalQty || 25;

  if (remaining <= 0) {
    currentStockEl.textContent = "0";
    totalStockEl.textContent = "";
    return;
  }

  //currentStockEl.textContent = remaining;
  currentStockEl.textContent = Math.min(remaining, total);
  totalStockEl.innerHTML = `/${total} pieces remaining`;
}
  
  // Listen for variant changes (to refresh display if needed)
  document.addEventListener('change', function(e) {
    if (e.target.closest('.js-product-form')) {
      setTimeout(updateInventoryDisplay, 100);
    }
  });
  
  // Initial display
  updateInventoryDisplay();
  
  // Optional: Auto-refresh every 30 seconds for real-time updates
  setInterval(updateInventoryDisplay, 30000);
  console.log("Variants:", productData.variants);
});